module.exports = __webpack_public_path__ + "img/gif.e6037a0d.gif";